import { mapSetFormatBase } from "../FsSetFormat";
import { mapPointsDistribution } from "../FsPointsDistribution";
import { FsRoundsKnockoutFormat } from "db/model/match/Set/RoundsKnockout/FsRoundsKnockoutFormat";
import { RoundsKnockoutFormat } from "model/Match/Set/RoundsKnockout/RoundsKnockoutFormat";
import { mapLivesRules } from "../Knockout/FsLivesRules";
import { mapMultiple } from "db/mapping/Utility";

export const mapRoundsKnockoutFormat = (
  fsModel: FsRoundsKnockoutFormat
): RoundsKnockoutFormat | undefined => {
  const base = mapSetFormatBase(fsModel);
  if (!base || !fsModel.lives || !fsModel.roundsPerTrack) {
    return undefined;
  }

  const lives = mapMultiple(fsModel.lives, mapLivesRules);
  if (!lives) {
    return undefined;
  }

  const points = !!fsModel.points
    ? mapPointsDistribution(fsModel.points)
    : undefined;

  return {
    ...base,
    lives,
    numTracks: fsModel.numTracks,
    playTillLeft: fsModel.playTillLeft ?? 1,
    points,
    roundsPerTrack: fsModel.roundsPerTrack,
    startingLives: fsModel.startingLives ?? 1,
  };
};
